import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <section className='footer'>
      <span>Developed by SuperGirlP 2024 || All rights reserved.</span>
    </section>
  )
}

export default Footer
